import { FormSchema } from "../../../components/dynamicform/DynamicFormTypes";

const doiUrlRegex = /^https:\/\/doi\.org\/10\.\d{4}\/[-a-zA-Z0-9.]+$/

export const preRegistrationForm: FormSchema = {
    title: "Pre-Registration",
    fields: [
        {
            name: "didPreregister",
            type: "radio",
            label: "Did you pre-register your paper?",
            required: true,
            defaultValue: "yes",
            validationRules: {
                required: true,
            },
            options: [
                { label: "Yes", value: "yes" },
                { label: "No", value: "no" },
            ],
        },
        {
            name: "doiUrl",
            type: "url",
            label: "Please enter the DOI for your pre-registration",
            defaultValue: "",
            validationRules: {
                pattern: {
                    value: doiUrlRegex,
                    message: 'Invalid DOI URL'
                }
            },
            placeholder: "https://doi.org/00.0000/a12345-123-1234-0"
        },
    ]
};